class YoutubeVideo extends HTMLElement {
  constructor() {
    super();
    this.player = null;
    this.isPlaying = true;
    this.isMuted = true;
    this.controller = new AbortController();
    this.playBtn = null;
    this.muteBtn = null;
    this.playBtnIcon = null;
    this.muteBtnIcon = null;
    this.unmuteBtnIcon = null;
    this.pauseBtnIcon = null;
  }

  connectedCallback() {
    this.playBtn = this.querySelector('[data-play-btn]');
    this.muteBtn = this.querySelector('[data-mute-btn]');
    this.playBtnIcon = this.querySelector('[data-play-btn-icon]');
    this.muteBtnIcon = this.querySelector('[data-mute-btn-icon]');
    this.unmuteBtnIcon = this.querySelector('[data-unmute-btn-icon]');
    this.pauseBtnIcon = this.querySelector('[data-pause-btn-icon]');

    const playerEl = this.querySelector('[data-youtube-video-player]');
    if (!playerEl) return;

    const videoId = playerEl.dataset.videoId;
    if (!videoId) return;

    this.playBtn?.addEventListener('click', () => this.togglePlay(), {
      signal: this.controller.signal,
    });
    this.muteBtn?.addEventListener('click', () => this.toggleMute(), {
      signal: this.controller.signal,
    });

    this.loadAPI(() => {
      this.player = new window.YT.Player(playerEl, {
        videoId,
        width: '100%',
        height: '100%',
        playerVars: {
          autoplay: 1,
          mute: 1,
          loop: 1,
          playsinline: 1,
          playlist: videoId,
          controls: 0,
          modestbranding: 1,
          rel: 0,
          iv_load_policy: 3,
          disablekb: 1,
          fs: 0,
        },
        events: {
          onReady: this.onPlayerReady.bind(this),
          onStateChange: (e) => {
            this.isPlaying = e.data === window.YT.PlayerState.PLAYING;
            this.updateIcons();
          },
        },
      });
    });
  }

  onPlayerReady() {
    if (this.player) {
      this.isMuted = this.player.isMuted();
      this.updateIcons();
      this.isPlaying = true;
    }
  }

  disconnectedCallback() {
    this.controller.abort();
    try {
      this.player?.destroy();
    } catch {
      /* already destroyed */
    }
  }

  togglePlay() {
    if (!this.player?.getPlayerState) return;
    this.isPlaying ? this.player.pauseVideo() : this.player.playVideo();
  }

  toggleMute() {
    if (!this.player?.isMuted) return;
    this.isMuted ? this.player.unMute() : this.player.mute();
    this.isMuted = !this.isMuted;
    this.updateIcons();
  }

  updateIcons() {
    this.playBtnIcon?.classList.toggle('hidden', this.isPlaying);
    this.pauseBtnIcon?.classList.toggle('hidden', !this.isPlaying);
    this.unmuteBtnIcon?.classList.toggle('hidden', this.isMuted);
    this.muteBtnIcon?.classList.toggle('hidden', !this.isMuted);
  }

  loadAPI(callback) {
    if (window.YT?.Player) return callback();

    if (!document.querySelector('script[src*="youtube.com/iframe_api"]')) {
      const tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      document.head.appendChild(tag);
    }

    const prev = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = () => {
      prev?.();
      callback();
    };

    // Fallback: poll in case the API was already loading
    const poll = setInterval(() => {
      if (window.YT?.Player) {
        clearInterval(poll);
        callback();
      }
    }, 100);
  }
}

if (!customElements.get('youtube-video')) {
  customElements.define('youtube-video', YoutubeVideo);
}
